import { render, staticRenderFns } from "./ProzessSchritte.vue?vue&type=template&id=3a5164d1&scoped=true&"
import script from "./ProzessSchritte.vue?vue&type=script&lang=js&"
export * from "./ProzessSchritte.vue?vue&type=script&lang=js&"
import style0 from "./ProzessSchritte.vue?vue&type=style&index=0&id=3a5164d1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a5164d1",
  null
  
)

export default component.exports